export enum ScreenSourceEnum {
	SaleOrder = 1,
	Patient = 2,
	Appointment = 3
}